import React from 'react';
import useStyle from './label.style';

export interface LabelProps {
  text: string;
  backgroundColor?: string;
}
const Label = ({ text, backgroundColor }: LabelProps) => {
  const classes = useStyle({ backgroundColor });
  return (
    <label className={classes.root}>
      <span>{text}</span>
    </label>
  );
};
export default Label;
